<template>
  <label
    class="c-toggle"
    :class="{ 'c-toggle--toggled': toggled }"
  >
    <input
      ref="toggleInput"
      type="checkbox"
      class="c-toggle__input"
      :checked="toggled"
      :disabled="disabled"
      tabindex="-1"
      @change.stop="toggle"
    />
    <div
      class="c-toggle__content"
      :class="{ [`c-toggle__content--${size}`]: size }"
      tabindex="0"
      @keyup.enter="click"
    />
  </label>
</template>

<script setup lang="ts">
import { computed, ref } from 'vue'

const emit = defineEmits<{
  (e: 'change', value: boolean): void
}>()

interface Props {
  size?: 'small' | 'medium'
  value?: boolean
  disabled?: boolean
}

const props = withDefaults(defineProps<Props>(), {
  size: 'medium',
  value: false,
  disabled: false,
})

const toggleInput = ref(null)

const toggled = computed(() => !!props.value)

const toggle = () => {
  emit('change', !toggled.value)
}

const click = () => {
  if (toggleInput.value) (toggleInput.value as HTMLInputElement).click()
}
</script>

<script lang="ts">
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'CToggle',
})
</script>
